module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/events/events.component.css
// module id = ./src/app/events/events.component.css
// module chunks = main